<template>
  <div class="pdf-viewer-wrapper">
    <a-button @click="$emit('close')" class="mb-3">← Späť na dokumenty</a-button>

<div class="pdf-container">
  <!-- Overlay loader -->
  <a-spin v-if="loadingPdf" tip="Načítavam PDF..." size="large" class="pdf-loader" />

  <!-- PDF canvas and markers -->
  <div style="position: relative">
    <canvas ref="pdfCanvas" @click="handleCanvasClick"></canvas>

    <span :key="renderKey">
      <div
        v-for="(comment, index) in isCanvasReady ? commentsOnCurrentPage : []"
        :key="comment.id"
      >
        <a-tooltip :title="comment.text || 'Nový komentár'" placement="bottom">
          <div @click.stop="selectComment(comment)" :style="getMarkerStyle(comment)">
            <i class="fas fa-comment-dots comment-marker"></i>
          </div>
        </a-tooltip>
      </div>
    </span>
  </div>
</div>

      <a-modal
        v-model="commentModalVisible"
        title="Komentár"
        :closable="true"
        :maskClosable="false"
        :footer="null"
        @open="focusCommentInput"
      >
        <div v-if="selectedComment">
          <a-textarea
            ref="commentInput"
            v-model="selectedComment.text"
            rows="4"
          />
          <div class="modal-footer">
            <a-button type="danger" @click="deleteComment">Zmazať</a-button>
            <a-button type="primary" @click="closeCommentModal">Uložiť</a-button>
          </div>
        </div>
      </a-modal>

      <div class="pagination-controls">
        <a-button @click="prevPage" :disabled="pageNumber <= 1">Predchádzajúca</a-button>
        <span>Strana {{ pageNumber }} / {{ numPages }}</span>
        <a-button @click="nextPage" :disabled="pageNumber >= numPages">Ďalšia</a-button>
      </div>


  <template v-if="!loadingPdf">
  <template v-if="commentsOnCurrentPage">
<div class="container mt-4 mb-4">
  <h5 class="mb-4">Komentáre v dokumente</h5>
  <a-list size="small" bordered :data-source="commentsOnCurrentPage"  item-layout="horizontal" style="max-height:300px; overflow-y:auto;">
          <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta :description="item.text" />
        </a-list-item>
      </a-list>
      </div>
  </template>
    </template>
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
  props: {
    src: String,
    value: Array,
  },
  data() {
    return {
      pdf: null,
      pageNumber: 1,
      renderKey: 0,
      numPages: 1,
      canvasWidth: 1,
      isCanvasReady: false,
      canvasHeight: 1,
      commentModalVisible: false,
      selectedComment: null,
      localComments: [],
        loadingPdf: true,
    };
  },
 watch: {
  src: {
    immediate: true,
    async handler(newVal) {
      this.resetViewer();
      if (newVal) {
        await this.$nextTick();
        setTimeout(() => this.loadPdf(), 100); // stačí kratšie oneskorenie
      }
    }
  },
  value: {
    handler(newVal) {
      this.localComments = [...newVal];
    },
    immediate: true,
    deep: true
  },
},
beforeDestroy() {
  const canvas = this.$refs.pdfCanvas;
  if (canvas) {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  this.pdf = null;
  this.localComments = [];
},
  computed: {
    commentsOnCurrentPage() {
      return this.localComments.filter(c => Number(c.page) === Number(this.pageNumber));
    }
  },
  mounted() {
   this.loadingPdf = true;
  setTimeout(() => {
    this.loadPdf();
    // loader sa vypne už vo vnútri loadPdf/renderPage
  }, 1500);
},
  methods: {
  resetViewer() {
  this.pdf = null;
  this.pageNumber = 1;
  this.numPages = 1;
  this.canvasWidth = 1;
  this.canvasHeight = 1;
  this.isCanvasReady = false;
  this.loadingPdf = true;
  this.renderKey++;
  this.selectedComment = null;

  const canvas = this.$refs.pdfCanvas;
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
},
async loadPdf() {
  try {
    const loadingTask = pdfjsLib.getDocument(this.src);
    this.pdf = await loadingTask.promise;
    this.numPages = this.pdf.numPages;
    await this.renderPage();
  } catch (error) {
    //this.$message.error('Nepodarilo sa načítať PDF súbor.');
    console.error(error);
  }

},
    async renderPage() {

      const page = await this.pdf.getPage(this.pageNumber);
      const viewport = page.getViewport({ scale: 1.5 });

      const canvas = this.$refs.pdfCanvas;
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      this.canvasWidth = viewport.width;
      this.canvasHeight = viewport.height;



      await this.$nextTick(); // počkať na mount
await page.render({ canvasContext: context, viewport }).promise;
this.isCanvasReady = true;
this.loadingPdf = false;
    },
    nextPage() {
      if (this.pageNumber < this.numPages) {
        this.pageNumber++;
        this.renderKey++;
        this.renderPage();
      }
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
        this.renderPage();
      }
    },
 handleCanvasClick(e) {
  const rect = this.$refs.pdfCanvas.getBoundingClientRect();
  const canvas = this.$refs.pdfCanvas;

  const x = (e.clientX - rect.left) / canvas.offsetWidth;
  const y = (e.clientY - rect.top) / canvas.offsetHeight;

  const newComment = {
    id: Date.now() + Math.random(),
    x,
    y,
    text: '',
    page: this.pageNumber,
  };

  this.localComments.push(newComment);
  this.$emit('update:comments', this.localComments);
  this.selectedComment = newComment;
  this.commentModalVisible = true;

  this.renderKey++; // núti prekreslenie

  this.$nextTick(() => this.focusCommentInput());
},
    selectComment(comment) {
      this.selectedComment = comment;
      this.commentModalVisible = true;
      this.$nextTick(() => this.focusCommentInput());
    },
    deleteComment() {
      this.localComments = this.localComments.filter(c => c.id !== this.selectedComment.id);
      this.$emit('update:comments', this.localComments);
      this.renderKey++;
      this.selectedComment = null;
      this.commentModalVisible = false;


    },
    closeCommentModal() {
      this.$emit('update:comments', this.localComments);
       this.$emit('save', 'comment'); // volanie do rodiča
      this.commentModalVisible = false;


    },
    focusCommentInput() {
      this.$refs.commentInput?.focus?.();
    },
getMarkerStyle(comment) {
  const canvas = this.$refs.pdfCanvas;
  if (!canvas || !canvas.offsetWidth || !canvas.offsetHeight) {
    return {
      top: '0px',
      left: '0px',
      display: 'none', // bezpečne skryť, ak nemáme rozmery
    };
  }

  const width = canvas.offsetWidth;
  const height = canvas.offsetHeight;

  return {
    top: comment.y * height + 'px',
    left: comment.x * width + 'px',
    position: 'absolute',
  };
},
  }
};
</script>

<style scoped>
.pdf-viewer-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pdf-container {
  position: relative;
  display: inline-block;
}
canvas {
  border: 1px solid #ccc;
}
.comment-marker {
  position: absolute;
  font-size: 18px;
  cursor: pointer;
  z-index: 10;
  color: #ffc107;
  font-size:25px;
    margin-top: -23px;
  line-height: 1;
}
.pdf-container canvas {
  display: block;
  margin: 0 auto;
}
.pdf-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.pdf-container {
  position: relative;
  min-height: 200px; /* aby mal kde loader byť aj bez canvasu */
}
canvas {
  display: block;
  border: 1px solid #ccc;
  background-image: none !important;
}

.modal-footer {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.pagination-controls {
  margin-top: 20px;
  margin-bottom:20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
